<template>
  <v-container text-xs-center>
    <v-layout row wrap>
      <v-container style="max-height: 75vh;" class="scrollDesign">
        <v-layout row wrap>
          <v-flex ma-1 xs12 class="expandableContainer">
            <v-data-table
              :headers="headers"
              :items="students"
              hide-actions
              ref="table"
              item-key="id"
              no-data-text="No tiene invitaciones"
            >
              <template v-slot:headers="props">
                <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
              </template>
              <template v-slot:items="props">
                <td>
                  <v-avatar size="30px">
                    <v-avatar
                      size="30px"
                      color="grey lighten-4"
                      v-if="props.item.image && props.item.image != 'data:image/jpeg;base64,undefined' && props.item.image != 'data:image/jpeg;base64,' && props.item.image != 'data:image/jpeg;base64, '"
                    >
                      <img
                        ref="image"
                        :src="'data:image/jpeg;base64,' + props.item.image"
                        alt="avatar"
                      />
                    </v-avatar>
                    <v-icon
                      v-else
                      :color="props.item.gender =='MALE' ? 'blue' : 'pink'"
                    >account_circle</v-icon>
                  </v-avatar>
                </td>
                <td>{{ props.item.firstName }}</td>
                <td>{{ props.item.lastName }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ["students"],
  data: () => ({
    headers: [
      {
        text: "Foto",
        align: "center",
        sortable: false,
        value: "photo"
      },
      {
        text: "Nombre",
        align: "center",
        sortable: false,
        value: "firstName"
      },
      {
        text: "Apellidos",
        align: "center",
        sortable: false,
        value: "lastName"
      }
    ]
  })
};
</script>
<style scoped>
td,
th {
  width: 464px;
  max-width: 464px;
  min-width: 464px;
}
</style>